/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { runtimeEnv } from "configuration";

const itwinVersion = "itwin-version";

export class AttributeSerializer {
  public static serialize(attributes: Record<string, string | boolean>): string[] {
    const serializedAttr: string[] = [];
    for (const key in attributes) {
      if (Object.prototype.hasOwnProperty.call(attributes, key)) {
        if (typeof attributes[key] === "string") {
          serializedAttr.push(`${key}:${attributes[key]}`);
        } else {
          serializedAttr.push(key);
        }

      }
    }
    return serializedAttr;
  }

  public static deserialize(attributes: string[]): Record<string, string | boolean> {
    const serializedAttr: Record<string, string | boolean> = {};

    attributes.forEach((attr) => {
      if (attr.includes(":")) {
        const splitVal = attr.split(":");
        if (splitVal.length !== 2) {
          throw Error(`Invalid attribute: ${attr}`);
        }
        serializedAttr[splitVal[0]] = splitVal[1];
      } else {
        serializedAttr[attr] = true;
      }
    });

    return serializedAttr;
  }

  public static getITwinVersion(attributes: string[]) {

    const attribute = attributes.find((item) => item.startsWith(itwinVersion));
    if (attribute)
      return attribute.slice(itwinVersion.length + 1);
    else
      return runtimeEnv.REACT_APP_PREFERRED_VERSION;
  }
}
